import app from 'app';
import 'bootstrap-datepicker';

const EditDateView = Backbone.View.extend({
  id: 'editDateView',
  /**
   * Destroy plugins and any non-default additional data or event-listeners
   */
  onClose: function () {
    this.$el.closest('.wt-scrollable').off('scroll.datepicker');
  },
  initialize: function (options) {
    this.model = options.model;
    this.date = app.moment(options.date ? new Date(options.date) : new Date());
    this.renderPublishDate = _.isUndefined(options.renderPublishDate)
      ? true
      : options.renderPublishDate;
    this.template = app.compileTemplate.$('#editDateView-tmpl');
  },

  /**
   * Render task view inner html (yet being DOM-detached)
   */
  render: function () {
    const context = {};
    context.hoursArray = _.map(_.range(1, 13), function (num) {
      return num < 10 ? '0' + num : num.toString();
    });
    context.minutesArray = _.map(_.range(0, 60), function (num) {
      return num < 10 ? '0' + num : num.toString();
    });
    context.ampmArray = ['AM', 'PM'];
    context.date = this.date.format('MM/DD/YYYY');
    context.hours = this.date.format('hh');
    context.minutes = this.date.format('mm');
    context.ampm = this.date.format('A');
    context.renderPublishDate = this.renderPublishDate;

    this.$el.html(this.template(context));

    this.$dateEl = this.$el.find('.date-part');

    return this.$el;
  },

  /**
   * Execute additional DOM related initialization when task view markup is attached to the DOM
   */
  domReady: function () {
    this.$dateEl.datepicker({ format: 'mm/dd/yyyy', autoclose: true });

    this.$el.closest('.wt-scrollable').on(
      'scroll.datepicker',
      $.proxy(function () {
        this.$dateEl.datepicker('place');
      }, this)
    );
  },
  events: {},

  getDate: function () {
    let dateResult;

    if (this.$dateEl) {
      const datePartVal = this.$dateEl.val();
      const hoursPartVal = this.$el.find('.hours-part').val();
      const minutesPartVa = this.$el.find('.minutes-part').val();
      const ampmPartVal = this.$el.find('.ampm-part').val();
      const fullDateString =
        datePartVal +
        ' ' +
        hoursPartVal +
        ':' +
        minutesPartVa +
        ' ' +
        ampmPartVal;

      dateResult = app.moment(fullDateString, 'MM/DD/YYYY hh:mm a');
    } else {
      dateResult = app.moment(new Date());
    }

    return dateResult.format('X') * 1000;
  },

  getRenderPublishDate: function () {
    return !this.$el.find('.hide-date').prop('checked');
  },

  toJSON: function () {
    return {
      publishedDate: this.getDate(),
      renderPublishDate: this.getRenderPublishDate(),
    };
  },
});
export default EditDateView;
